import React from "react"
import styled from "@emotion/styled"
import { P, Span } from "../../styled/typography.styled"

const StyledDiv = styled.div`
  border-color: #077ced;
  position: relative;
  padding: 25px 0 20px 40px;

  ::before {
    content: "";
    position: absolute;
    display: block;
    height: 100%;
    background-color: #333;
    width: 1px;
    left: 15px;
    bottom: 5px;
  }

  ::after {
    content: "";
    position: absolute;
    display: block;
    height: ${({ height }) => (height ? 0 : "1px")};
    background-color: #333;
    width: calc(100% - 15px);
    left: 15px;
    bottom: 3px;
  }
`

const StyledH5 = styled.h5`
  display: inline-block;
  position: relative;
  font-size: 12px;
  font-weight: 500;
  margin: 0 0 5px -40px;
  color: #fff;
  background-color: #333;
  padding: 0 10px;
  line-height: 23px;
  border: 2px solid #007ced;
  border-radius: 30px;
`

export const H4 = styled.h4`
  font-size: 16px;
  margin: 10px 0 7px;
  color: #f5f5f5;
  font-family: "Poppins", Helvetica, sans-serif;
  font-weight: 600;
  font-style: normal;
  line-height: 1.2;
`

const StyledSpan = styled(Span)`
  display: inline-block;
  font-size: 12px;
  color: #aaa;
  opacity: 0.7;
  margin-left: 5px;
`
const StyledP = styled(P)`
  font-size: 0.92em;
  box-sizing: border-box;
  font-weight: 400;
  font-style: normal;
  line-height: 1.75em;
  color: #d5d5d5;
`

const Card = ({ date, placeName, title, description, height }) => {
  return (
    <StyledDiv height={height ? 1 : 0}>
      <StyledH5>{date}</StyledH5>
      <StyledSpan>{placeName}</StyledSpan>
      <H4>{title}</H4>
      <StyledP>{description}</StyledP>
    </StyledDiv>
  )
}

export default Card
